import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ErrorModal = ({ modal, setModal }) => {
	const { t } = useTranslation();
	const AuthData = useSelector((state) => state.Auth);

	return (
		<Modal
			isOpen={modal}
			toggle={() => setModal(false)}
			style={{
				maxWidth: "600px",
				marginTop: "10%",
				width: "100%",

				borderRadius: "25px",
			}}
			className={`error-modal ${AuthData.lang !== "ar" ? "" : "ar-wrapper"}`}>
			<ModalBody>
				<div
					className="overflow-hidden m-0 p-0"
					style={{ direction: "inherit" }}>
					<div className=" p-0 m-0">
						<p className="mb-3 text-primary bask-font text-center error-title">
							{t("error")}
						</p>
						<p className="m-0 text-primary text-center font-size-14">
							{t(
								"YOU CAN’T USE THE INTERACTIVE MODE UNLESS YOU CHOOSE OPTIONS FROM THE ABOVE"
							)}
						</p>
					</div>
				</div>
			</ModalBody>
		</Modal>
	);
};

export default ErrorModal;
